import React, { useEffect, useMemo, useRef } from "react";
import {
  AutoResizeTextArea,
  CheckBoxInput,
  FormContainer,
  FormGroupLabel,
  FormItem,
  Label,
  LinkSpan,
} from "../../shared/components/form/FormElements";
import SelectSuggestedPartsPopup from "../Inventory/components/SelectSuggestedPartsPopup";
import { Col, Container, Row } from "react-bootstrap";
import FormHeader from "../../shared/components/form/FormHeader";
import { Card, CardBody } from "@/shared/components/Card";
import FormField from "../../shared/components/form/FormField";
import Error from "@/shared/components/form/Error";
import { useState } from "react";
import { useHistory, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { formInputStyles, formStyles } from "../../shared/constants/styles";
import { Desc } from "../Reminders/MaintenanceReminders/MaintenanceRemindersForm";
import { post, postApi } from "../../api/getUser";
import { useDispatch } from "react-redux";
import { addMsg } from "../../features/snackbar/snackbarSlice";
import { useSelector } from "react-redux";
import {
  fetchServicesTasks,
  fetchServiceTaskCategories,
} from "../../features/servicesTasks/servicesTasksSlice";
import ErrorPopup from "../../shared/components/ErrorPopup";
import useAutosizeTextArea from "../../shared/custom-hooks/useAutosizeTextArea";
import AssetDropdown from "../../shared/components/AssetDropdown";
import { useServiceTaskCategory } from "../../shared/custom-hooks/useServiceTaskCategory";
import AddServiceTaskCategoryPopup from "./AddServiceTaskCategoryPopup";
import ServiceTaskCategoryOption from "./ServiceTaskCategoryOption";
import CustomMenuList from "../../shared/components/form/CustomMenuList";
import { NewBadge } from "../../containers/Layout/components/sidebar/SidebarLink";
import { colorLightGray } from "../../utils/palette";
import { useAuth } from "../../contexts/AuthContext";
import SubscribePopup from "../../shared/components/SubscribePopup";

const ServiceTasksForm = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation("common");
  const {
    handleSubmit,
    reset,
    register,
    control,
    watch,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const { tag } = useAuth();

  const vehiclesList = useSelector((state) => state.vehicles.list);
  const vehicles = useMemo(
    () => vehiclesList.filter((v) => v.veh_active === 1),
    [vehiclesList],
  );

  const { userId } = useSelector((state) => state.user);

  const type = location?.state?.type;
  const rowData = location?.state?.rowData;

  const serviceTaskOptions = useSelector((state) => state.servicesTasks.list);
  const allServiceTaskCategories = useSelector(
    (state) => state.servicesTasks.allServiceTaskCategories,
  );
  //const allVehicles = useSelector((state) => state.vehicles.list);

  const [showSubscribePopup, setShowSubscribePopup] = useState(false);
  const [subscribePopupErrMsg, setsubscribePopupErrMsg] = useState("");

  //Coming from Add Service
  const mode = location?.state?.mode;
  const fromType = location?.state?.fromType;
  const route = location?.state?.route;
  const redirect = location?.state?.redirect;
  const routeData = location?.state?.routeData;
  const serviceData = location?.state?.routeData?.serviceData;
  //console.log(mode, route, redirect);

  const {
    showServiceTaskCategoryPopup,
    setShowServiceTaskCategoryPopup,
    tempServiceTaskCategoryData,
    setTempServiceTaskCategoryData,
    serviceTaskCategoryPopupErr,
    isServiceTaskCategorySaving,
    isServiceTaskCategoryDeleting,
    handleCreateServiceTaskCategory,
    handleSaveServiceTaskCategory,
    handleDeleteServiceTaskCategory,
    handleCloseServiceTaskCategoryPopup,
  } = useServiceTaskCategory();

  const [recurringTask, setRecurringTask] = useState(false);
  const [applyToAllVeh, setApplyToAllVeh] = useState(true);

  const [saveBtnLoading, setSaveBtnLoading] = useState(false);

  const [suggestedParts, setSuggestedParts] = useState([]);
  const [laborHours, setLaborHours] = useState(0);
  const [laborMinutes, setLaborMinutes] = useState(0);
  const [showAddPartsPopup, setShowAddPartsPopup] = useState(false);

  //To toggle error popup while adding/editing form
  const [showErrPopup, setShowErrPopup] = useState(false);

  const serviceTaskName = watch("serviceTaskName");
  const vehicle = watch("vehicle");
  const comments = watch("comments");
  const serviceTaskCategory = watch("serviceTaskCategory");

  const textAreaRef = useRef(null);
  useAutosizeTextArea(textAreaRef.current, comments);

  const isEquipment = vehicle?.asset_type === 1 && !applyToAllVeh;

  // Fetch service task categories on mount
  useEffect(() => {
    dispatch(fetchServiceTaskCategories());
  }, []);

  //Effect for populating Edit Data
  useEffect(() => {
    if (type === "edit" && vehicles.length > 0) {
      const {
        service_task_name,
        comments,
        recurring,
        veh_id,
        st_category_id,
        category_name,
        suggestedParts,
        estimated_time,
      } = rowData;

      console.log("rowData", rowData);

      setValue("serviceTaskName", service_task_name);
      setValue("comments", comments);
      setRecurringTask(recurring);
      setApplyToAllVeh(veh_id === "All");

      if (st_category_id && category_name) {
        setValue("serviceTaskCategory", {
          label: category_name,
          value: st_category_id,
        });
      }

      if (veh_id !== "All") {
        setValue(
          "vehicle",
          vehicles.find((v) => v.veh_id === veh_id),
        );
      }

      if (suggestedParts) {
        setSuggestedParts(suggestedParts);
      }

      if (estimated_time) {
        const hours = Math.floor(estimated_time / 3600);
        const minutes = Math.floor((estimated_time % 3600) / 60);
        setLaborHours(hours);
        setLaborMinutes(minutes);
      }
    }

    if (redirect) {
      setValue("serviceTaskName", routeData?.serviceTaskName);
    }
  }, [vehicles]);

  const onSubmit = async () => {
    try {
      if (type !== "edit") {
        for (let serviceTask of serviceTaskOptions) {
          if (applyToAllVeh) {
            if (
              serviceTask.service_task_name.toLocaleLowerCase() ===
              serviceTaskName?.trim().toLocaleLowerCase()
            ) {
              setError(
                "serviceTaskName",
                {
                  type: "custom",
                  message: t("dup_service_task_name_error"),
                },
                { shouldFocus: true },
              );
              return;
            }
          } else {
            if (
              serviceTask.service_task_name.toLocaleLowerCase() ===
                serviceTaskName?.trim().toLocaleLowerCase() &&
              (serviceTask.veh_id === vehicle.veh_id ||
                serviceTask.veh_id === "All")
            ) {
              setError(
                "serviceTaskName",
                {
                  type: "custom",
                  message: t("dup_service_task_name_error"),
                },
                { shouldFocus: true },
              );
              return;
            }
          }
        }
      }

      const serviceTaskId =
        type === "edit" ? rowData?.service_task_id : `${userId}_${Date.now()}`;

      const snackbarMsg =
        type === "edit"
          ? t("record_edited_msg", { recordName: t("service_task") })
          : t("record_added_msg", { recordName: t("service_task") });

      const suggestedPartIds = !isEquipment ? suggestedParts.map((p) => p.part_id) : [];
      //Estimated labor time will be in seconds
      const estimatedLaborTime = !isEquipment ? laborHours * 60 * 60 + laborMinutes * 60 : 0;

      const apiData = {
        sync_version: "v2",
        querystring: "add_service_task_v2",
        source: "web",
        service_tasks: [
          {
            service_task_id: serviceTaskId,
            service_task_name: serviceTaskName,
            recurring: recurringTask ? 1 : 0,
            servicetask_veh_id: applyToAllVeh ? "All" : vehicle.veh_id,
            comments: comments,
            source: "web",
            sync_version: "v2",
            action: type === "edit" ? 2 : 1,
            st_category_id: serviceTaskCategory?.value || "",
            suggested_parts: suggestedPartIds,
            estimated_time: estimatedLaborTime,
          },
        ],
      };

      setSaveBtnLoading(true);
      const response = await post("commonNew", apiData);

      if (!response?.success) {
        setSaveBtnLoading(false);
        setShowErrPopup(true);
        return;
      }

      if (response.success === 1) {
        setSaveBtnLoading(false);
        const apiData = {
          querystring: "getallservicetask",
          service_veh_id: "All",
        };
        dispatch(fetchServicesTasks(apiData));

        if (mode === "from-add-service") {
          history.push("/services/services/addnew", {
            mode: "from-add-service-task",
            routeData: { serviceTaskId, serviceData },
            fromType: fromType,
          });
        } else if (redirect) {
          history.push(route, {
            mode: "from-add-service-task",
            routeData: { serviceTaskId },
            fromType: fromType,
          });
        } else {
          dispatch(addMsg(snackbarMsg));
          history.push("/services/servicetasks", { fromCancel: false });
        }
      }
    } catch (e) {
      setSaveBtnLoading(false);
      setShowErrPopup(true);
      return;
    }
  };

  return (
    <>
      {showSubscribePopup && (
        <SubscribePopup
          showPopup={showSubscribePopup}
          setShowPopup={setShowSubscribePopup}
          message={subscribePopupErrMsg}
        />
      )}
      {showErrPopup && (
        <ErrorPopup showPopup={showErrPopup} setShowPopup={setShowErrPopup} />
      )}
      {showAddPartsPopup && (
        <SelectSuggestedPartsPopup
          showPopup={showAddPartsPopup}
          setShowPopup={setShowAddPartsPopup}
          alreadySelectedParts={suggestedParts}
          onPartsSubmitted={(parts) => setSuggestedParts(parts)}
        />
      )}
      {showServiceTaskCategoryPopup && (
        <AddServiceTaskCategoryPopup
          showPopup={showServiceTaskCategoryPopup}
          setShowPopup={setShowServiceTaskCategoryPopup}
          categoryData={tempServiceTaskCategoryData}
          onSave={(data) =>
            handleSaveServiceTaskCategory({ ...data, setValue, watch })
          }
          onDelete={(categoryId) =>
            handleDeleteServiceTaskCategory(categoryId, setValue, watch)
          }
          onClose={handleCloseServiceTaskCategoryPopup}
          isCreateNew={tempServiceTaskCategoryData?.__isNew__}
          error={serviceTaskCategoryPopupErr}
          isSaving={isServiceTaskCategorySaving}
          isDeleting={isServiceTaskCategoryDeleting}
        />
      )}
      <FormContainer onSubmit={handleSubmit(onSubmit)}>
        <FormHeader
          //title={t("add_service")}
          handleCancel={() =>
            history.push("/services/servicetasks", { fromCancel: true })
          }
          //disableSave={!vehicle}
          isSaveLoading={saveBtnLoading}
          title={
            type === "edit" ? t("edit_service_task") : t("add_service_task")
          }
          //handleCancel={handleCancel}
        />
        <Container>
          <Card>
            <CardBody
              style={{
                height: `${window.innerHeight - 150}px`,
                overflow: "auto",
              }}
            >
              <Row>
                <Col md={4}>
                  <FormGroupLabel>{t("service_task_name")}</FormGroupLabel>
                  <FormItem disabled={false}>
                    <FormField
                      name="serviceTaskName"
                      control={control}
                      component="input"
                      defaultValue=""
                      placeholder={t("service_task_name")}
                      style={formInputStyles}
                      disabled={false}
                      rules={{ required: t("required_err") }}
                    />
                  </FormItem>

                  {errors?.serviceTaskName && (
                    <Error error={errors.serviceTaskName.message} />
                  )}
                </Col>
                {/* </Row> */}
                {/* <Row> */}
                <Col md={4}>
                  <FormGroupLabel className="d-flex align-items-center gap-1">
                    {t("service_task_category")}
                    {/* <NewBadge bg="custom">
                      <span style={{ fontSize: "8px", color: "black" }}>
                        {t("new")}
                      </span>
                    </NewBadge> */}
                  </FormGroupLabel>
                  <Controller
                    name="serviceTaskCategory"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <CreatableSelect
                        options={allServiceTaskCategories}
                        value={value}
                        onChange={onChange}
                        onCreateOption={handleCreateServiceTaskCategory}
                        placeholder={t("service_task_category_placeholder")}
                        styles={formStyles}
                        isClearable
                        components={{
                          Option: (optionProps) => (
                            <ServiceTaskCategoryOption
                              {...optionProps}
                              setShowServiceTaskCategoryPopup={
                                setShowServiceTaskCategoryPopup
                              }
                              setTempServiceTaskCategoryData={
                                setTempServiceTaskCategoryData
                              }
                            />
                          ),
                          MenuList: CustomMenuList,
                        }}
                        onCreateNew={() => handleCreateServiceTaskCategory("")}
                        createNewLabel={t("create_new_service_task_category")}
                        customProps={{ type: "serviceTaskCategory" }}
                        id="service-task-category-dropdown"
                      />
                    )}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={8}>
                  <FormGroupLabel>{t("notes_tv")}</FormGroupLabel>
                  {/* <FormItem disabled={false}>
                    <FormField
                      name="comments"
                      control={control}
                      component="input"
                      defaultValue=""
                      placeholder={t("notes_tv")}
                      style={formInputStyles}
                      disabled={false}
                    />
                  </FormItem> */}

                  <Controller
                    name="comments"
                    control={control}
                    //defaultValue={users?.length > 0 ? users[0] : ""}
                    //errors={errors}
                    render={({ field: { onChange, value, ref } }) => (
                      <AutoResizeTextArea
                        ref={textAreaRef}
                        onChange={onChange}
                        value={value}
                        placeholder={t("notes_tv")}
                        rows={1}
                        //isDisabled={status == 1 || status == 2}
                      />
                    )}
                    //rules={{ required: t("required_err") }}
                  />

                  {errors?.comments && (
                    <Error error={errors.comments.message} />
                  )}
                </Col>
              </Row>

              <Row className="pt-3">
                <Col md={12}>
                  <CheckBoxInput
                    type="checkbox"
                    id="recurringTask"
                    name="recurringTask"
                    value="recurringTask"
                    checked={recurringTask}
                    onChange={() => setRecurringTask((prev) => !prev)}
                    style={{ margin: "0 8px 0 0" }}
                  />
                  <Label htmlFor="recurringTask">{t("recurring_task")}</Label>
                </Col>
                <Desc style={{ paddingLeft: "2rem" }}>
                  {t("no_reminder_for_nonrecurring")}
                </Desc>
              </Row>
              <Row className="pt-3">
                <Col md={2} className="pt-2">
                  <CheckBoxInput
                    type="checkbox"
                    id="applyToAllVeh"
                    name="applyToAllVeh"
                    value="applyToAllVeh"
                    checked={applyToAllVeh}
                    onChange={() => setApplyToAllVeh((prev) => !prev)}
                    style={{ margin: "0 8px 0 0" }}
                  />
                  <Label htmlFor="applyToAllVeh">{t("apply_all_vehs")}</Label>
                </Col>
                {!applyToAllVeh && (
                  <Col md={4}>
                    {/* <FormGroupLabel className="m-0">{t("vehicle")}</FormGroupLabel> */}
                    <Controller
                      name="vehicle"
                      control={control}
                      //errors={errors}
                      render={({ field: { onChange, value, ref } }) => (
                        // <Select
                        //   options={vehicles}
                        //   value={value}
                        //   onChange={onChange}
                        //   //onCreateOption={handleCreate}
                        //   placeholder={t("vehicle_placeholder")}
                        //   styles={formStyles}
                        //   isDisabled={false}
                        // />
                        <AssetDropdown
                          vehicle={value}
                          onChange={onChange}
                          assets={vehicles}
                          isEquipmentSupported={true}
                          isForm={true}
                          placeholder={t("search_assets")}
                        />
                      )}
                      rules={{ required: t("required_err") }}
                    />

                    {errors?.vehicle && (
                      <Error error={errors.vehicle.message} />
                    )}
                  </Col>
                )}
              </Row>
              {/* Suggested Parts + Est. Labor Time box */}
              {!isEquipment && (
                <div
                  style={{
                    border: `1px solid ${colorLightGray}`,
                    borderRadius: "6px",
                    padding: "12px",
                    marginTop: "20px",
                    backgroundColor: "#f9fafb",
                  }}
                >
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#888",
                      marginTop: "8px",
                      marginBottom: 0,
                    }}
                  >
                    {t("suggested_parts_defaults_hint")}
                  </p>
                  <Row>
                    <Col md={8}>
                      <FormGroupLabel>{t("suggested_parts")}</FormGroupLabel>
                      {suggestedParts.length === 0 ? (
                        <p
                          style={{
                            fontSize: "13px",
                            color: "#888",
                            margin: "4px 0",
                          }}
                        >
                          {t("no_parts_added_yet")}
                        </p>
                      ) : (
                        <div
                          style={{
                            border: `1px solid ${colorLightGray}`,
                            borderRadius: "5px",
                            overflow: "hidden",
                            marginBottom: "8px",
                          }}
                        >
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                            }}
                          >
                            <thead>
                              <tr style={{ backgroundColor: "#f9f9f9" }}>
                                <th
                                  style={{
                                    fontSize: "11px",
                                    fontWeight: 400,
                                    color: "#888",
                                    textTransform: "uppercase",
                                    padding: "6px",
                                    textAlign: "left",
                                  }}
                                >
                                  {t("part_name")}
                                </th>
                                <th
                                  style={{
                                    fontSize: "11px",
                                    fontWeight: 400,
                                    color: "#888",
                                    textTransform: "uppercase",
                                    padding: "6px",
                                    textAlign: "left",
                                  }}
                                >
                                  {t("part_no")}
                                </th>
                                <th style={{ width: "32px" }} />
                              </tr>
                            </thead>
                            <tbody style={{ backgroundColor: "white" }}>
                              {suggestedParts.map((part, idx) => (
                                <tr
                                  key={part.part_id || idx}
                                  style={{ borderTop: "1px solid #eee" }}
                                >
                                  <td
                                    style={{ fontSize: "13px", padding: "6px" }}
                                  >
                                    {part.part_name}
                                  </td>
                                  <td
                                    style={{
                                      fontSize: "13px",
                                      padding: "6px",
                                    }}
                                  >
                                    {part.part_number || "—"}
                                  </td>
                                  <td>
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        color: "#888",
                                        fontSize: "16px",
                                        lineHeight: 1,
                                      }}
                                      onClick={() =>
                                        setSuggestedParts((prev) =>
                                          prev.filter((_, i) => i !== idx),
                                        )
                                      }
                                    >
                                      &times;
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                      <LinkSpan
                        onClick={() => {
                          if (tag === "essential-user") {
                            setsubscribePopupErrMsg(
                              t("subscribe_to_advanced_msg"),
                            );
                            setShowSubscribePopup(true);
                            return;
                          }
                          setShowAddPartsPopup(true);
                        }}
                        style={{ fontSize: "13px" }}
                      >
                        + {t("add_suggested_parts")}
                      </LinkSpan>
                    </Col>
                  </Row>

                  <hr className="mt-3 mb-0" />
                  {/* Est. Labor Time */}
                  <Row>
                    <Col md={6}>
                      <FormGroupLabel>{t("est_labor_time")}</FormGroupLabel>
                      <div className="d-flex align-items-center gap-2">
                        <select
                          value={laborHours}
                          onChange={(e) =>
                            setLaborHours(Number(e.target.value))
                          }
                          style={{
                            width: "70px",
                            padding: "4px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                          }}
                        >
                          {Array.from({ length: 51 }, (_, i) => (
                            <option key={i} value={i}>
                              {i}
                            </option>
                          ))}
                        </select>
                        <span style={{ fontSize: "13px" }}>
                          {t("hrs_label")}
                        </span>
                        <select
                          value={laborMinutes}
                          onChange={(e) =>
                            setLaborMinutes(Number(e.target.value))
                          }
                          style={{
                            width: "70px",
                            padding: "4px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                          }}
                        >
                          {[0, 15, 30, 45].map((m) => (
                            <option key={m} value={m}>
                              {m}
                            </option>
                          ))}
                        </select>
                        <span style={{ fontSize: "13px" }}>
                          {t("min_label")}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </CardBody>
          </Card>
        </Container>
      </FormContainer>
    </>
  );
};

export default ServiceTasksForm;
